import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    redirect: '/Home',
    children: [{
      path: 'Home',
      name: 'Home',
      meta: {
        title: 'Home'
      },
      component: () => import('../views/Home.vue')// 首页
    },
    {
      path: 'GoodsList',
      name: 'GoodsList',
      meta: {
        title: 'GoodsList'
      },
      component: () => import('../views/GoodsList.vue')
    },
    {
      path: 'Sweat',
      name: 'Sweat',
      meta: {
        title: 'Sweat'
      },
      component: () => import('../views/Sweat.vue')
    },
    {
      path: 'StoreDetails',
      name: 'StoreDetails',
      meta: {
        title: 'StoreDetails'
      },
      component: () => import('../views/StoreDetails.vue')
    },
    {
      path: 'Seamless',
      name: 'Seamless',
      meta: {
        title: 'Seamless'
      },
      component: () => import('../views/Seamless.vue')
    },
    {
      path: 'Warp',
      name: 'Warp',
      meta: {
        title: 'Warp'
      },
      component: () => import('../views/Warp.vue')
    },
    {
      path: 'OurYarns',
      name: 'OurYarns',
      meta: {
        title: 'OurYarns'
      },
      component: () => import('../views/OurYarns.vue')
    },
    {
      path: 'OurCertifications',
      name: 'OurCertifications',
      meta: {
        title: 'OurCertifications'
      },
      component: () => import('../views/OurCertifications.vue')
    },
    {
      path: 'DyeingInnovation',
      name: 'DyeingInnovation',
      meta: {
        title: 'DyeingInnovation'
      },
      component: () => import('../views/DyeingInnovation.vue')
    },
    {
      path: 'Headquarters',
      name: 'Headquarters',
      meta: {
        title: 'Headquarters'
      },
      component: () => import('../views/Headquarters.vue')
    },
    {
      path: 'Locations',
      name: 'Locations',
      meta: {
        title: 'Locations'
      },
      component: () => import('../views/Locations.vue')
    },
    {
      path: 'Partners',
      name: 'Partners',
      meta: {
        title: 'Partners'
      },
      component: () => import('../views/Partners.vue')
    },
    {
      path: 'OurTeam',
      name: 'OurTeam',
      meta: {
        title: 'OurTeam'
      },
      component: () => import('../views/OurTeam.vue')
    },
    {
      path: 'Link',
      name: 'Link',
      meta: {
        title: 'Link'
      },
      component: () => import('../views/Link.vue')
    },
    {
      path: 'Search',
      name: 'Search',
      meta: {
        title: 'Search'
      },
      component: () => import('../views/Search.vue')
    }
    ]
  }
]
const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  }
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
